import React, { memo } from 'react';
import { useDispatch, useSelector } from "react-redux";

import { IconComponent } from "../../reusable/simpleComponents";
import service from '../../../services';
import { ApplicationState } from "../../../store";
import { TimelineState } from "../../../store/timeline/types";
import { APIState } from "../../../store/API/types";
import { BrowseState } from "../../../store/browse/types";
import { getLocalBounds, playBackUpdateTimeCb } from '../../../utils';
import { setPlaybackmode } from "../../../store/timeline/actions";



const StepBackUIComponent = () => {
  const {time, playbackMode} = useSelector<ApplicationState, TimelineState>(state => state.timeline);
  const {browsePanes} = useSelector<ApplicationState, BrowseState>(state => state.browse);
  const {token} = useSelector<ApplicationState, APIState>(state => state.API);
  const dispatch = useDispatch();

  const handler = () => {
    const panes = Object.keys(browsePanes);
    if (playbackMode !== 'pause') dispatch(setPlaybackmode('pause'));

    const updateTime = playBackUpdateTimeCb(time, dispatch);

    panes.forEach(pane => {
      const camId = browsePanes[pane].id;
      const paneId = `thumbnail-${pane}`;
      const {width} = getLocalBounds(document.getElementById(paneId));
      service.browseMoveStep({
        token,
        pane: parseInt(pane),
        id: paneId,
        cb: updateTime,
        dir: -1,
        camId,
        width: Math.floor(width),
        time
      });
    })
  };

  return (
    <IconComponent classValue={'player step-back icon playback-icon'}
                   handler={handler}
                   title="Step Back One Frame"
    />
  )
};

export default memo(StepBackUIComponent);